/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { initialState } from './defaultState';
import {
  setProductsList,
  setViewedProduct,
  fetchSingleProduct,
} from './actions';

const productsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setViewedProduct, (state, action) => {
      state.viewedProduct = action.payload.viewedProduct;
    })
    .addCase(setProductsList, (state, action) => {
      state.productsList = action.payload.productsList;
    })
    .addCase(fetchSingleProduct, (state, action) => {
      state.viewedProduct = action.payload.productId;
    });
});

export default productsReducer;
